<template>
  <div>
    <v-form @submit.prevent="submit">
      <v-card class="mx-auto my-8">
        <v-card-title
          ><span class="headline">Account Details</span></v-card-title
        >
        <v-card-text>
          <v-text-field
            required
            name="first_name"
            label="First Name"
            v-model="formData.first_name"
            :error="errors.first_name !== undefined"
            :error-messages="errors.first_name"
          />
          <v-text-field
            required
            name="last_name"
            label="Last Name"
            v-model="formData.last_name"
            :error="errors.last_name !== undefined"
            :error-messages="errors.last_name"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn type="submit" outlined color="success" class="mx-auto">
            <span>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-snackbar v-model="snackbar.show" top :timeout="5000">
      {{ snackbar.message }}
      <v-btn color="success" text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "UserDetailsForm",
  components: {},
  data() {
    return {
      formData: {
        first_name: "",
        last_name: ""
      },
      snackbar: { show: false, message: "" },
      errors: {}
    };
  },
  computed: {
    ...mapGetters("accounts", ["currentUser"])
  },
  mounted() {
    this.formData = { ...this.currentUser };
  },
  methods: {
    ...mapActions("accounts", ["changeUserDetails"]),
    async submit() {
      try {
        this.snackbar.show = false;
        this.snackbar.message = "";
        await this.changeUserDetails(this.formData);
        this.errors = {};
        this.snackbar.message = "Account details have been updated.";
        this.snackbar.show = true;
      } catch (e) {
        this.errors = e.response.data;
      }
    }
  }
};
</script>
